"use client";

import { useAccount } from "wagmi";
import { ActivityPanel } from "@/components/common/activity-panel";

export function BridgeActivity() {
  const { isConnected, address } = useAccount();

  return (
    <ActivityPanel
      key={address || "disconnected"}
      isConnected={isConnected}
      mode="bridge"
      showFilters={true}
      itemsPerPage={4}
      compact={false}
    />
  );
}
